<template lang="html">
  <div class="devis">
    <div class="devis-background" :style="`background:url(/static/images/dupont_corian_${color.src}.jpg)`">
    </div>
    <div class="devis-parts">
    <p class="info">
      Estimez en direct le prix de votre projet cuisine ou salle de bains, grâce à notre outil de simulation. Remplissez les champs suivants. Validez. Nous calculons le coût de votre plan de travail en temps réel.
    </p>
    <div class="part" id="materiaux">
      <h1>Votre matériau</h1>
      <Coloris @changeColor="changeColor($event)" />
    </div>
    <div class="part" id="taille-plan">
      <h1>Votre plan de travail en mm (épaisseur 12mm)</h1>
      <TaillePlan :group="$store.state.devis[0].group" />
    </div>
    <div class="separator"></div>
    <div class="part" id="epaisseur-chant">
      <h1>Épaisseur et longueur du chant en mm</h1>
      <FormeBordure :longueur="$store.state.devis[1].longueur" />
    </div>
    <div class="part" id="taille-credence">
      <h1>Crédence en mm (épaisseur 12mm)</h1>
      <TailleCredence :group="$store.state.devis[0].group" />
    </div>
    <div class="separator"></div>
    <div class="part" id="options">
      <h1 class="blue">Options et découpe</h1>
      <Options />
    </div>
    <div class="separator"></div>
    <div class="part" id="services">
      <h1 class="blue">Services</h1>
      <Services />
    </div>
    <div class="separator"></div>
    <div class="part" id="">
      <h1 class="blue">T.V.A. réduite (10%)</h1>
      <div class="service">
         <Tva />
      </div>

    </div>
    <div class="separator"></div>
    <div class="part">
      <h1 class="blue" style="margin-bottom: 15px">Vos coordonnées</h1>
      <Coordonnees />
    </div>
  </div>
  <div class="devis-fixed">
    <Price />
    <div class="part">
    </div>
    <button @click="download()" class="download" v-if="!done && !loading">Télécharger votre devis</button>
    <button class="download" v-if="!done && loading"><i class="fa fa-circle-o-notch"></i>Veuillez patienter...</button>
    <button class="download" v-if="done && !loading"><i class="fa fa-check" style="margin-right: 10px"></i>Merci de vérifier votre boite mail</button>
  </div>
  <Foot />
  </div>
</template>

<script>
import Coloris from '@/components/parts/Coloris.vue'
import FormeBordure from '@/components/parts/FormeBordure.vue'
import TaillePlan from '@/components/parts/TaillePlan.vue'
import TailleCredence from '@/components/parts/TailleCredence.vue'
import Options from '@/components/parts/Options.vue'
import Services from '@/components/parts/Services.vue'
import Coordonnees from '@/components/parts/Coordonnees.vue'
import Price from '@/components/parts/Price.vue'
import Tva from '@/components/parts/Tva.vue'

import {options, services, chants, groups} from '../assets/configuration.js'

import jump from 'jump.js'
import axios from 'axios'
import Foot from '@/components/Foot.vue'

export default {
  components: {
    Foot,
    Coloris,
    TaillePlan,
    TailleCredence,
    FormeBordure,
    Options,
    Services,
    Coordonnees,
    Price,
    Tva
  },
  data () {
    return {
      options,
      groups,
      services,
      chants,
      color: {name: 'Abalone', src: 'abalone'},
      price: 0,
      loading: false,
      done: false
    }
  },
  watch: {
    $route () {
      if (typeof this.$route.hash !== 'undefined' && this.$route.hash !== '') {
        jump(this.$route.hash, {offset: -50})
      }
    }
  },
  methods: {
    beautify (price) {
      return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    },
    checkEmail (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    verify () {
      var ok = true
      var e = ''
      if (this.$store.state.devis[6].plans.length <= 0) {
        e += 'Les dimensions de votre plan de travail sont incorrectes.\n'
        ok = false
      }
      // if (this.$store.state.devis[7].credences.length <= 0) {
      //   e += 'Les dimensions de votre crédence sont incorrectes.\n'
      //   ok = false
      // }

      if (this.$store.state.user.name === '' || this.$store.state.user.email === '' || this.$store.state.user.phone === '' || this.$store.state.user.address === '' || this.$store.state.user.city === '' || this.$store.state.user.zip === '') {
        e += 'Merci de renseigner toutes vos coordonnées\n'
        ok = false
      } else {
        // coordonnées ok, verify email
        if (!this.checkEmail(this.$store.state.user.email)) {
          e += 'Merci de renseigner une adresse mail correcte\n'
          ok = false
        }
      }

      if (!ok) {
        alert(e)
      }
      return ok
    },
    download () {
      // console.log(JSON.stringify(this.$store.state))
      if (this.verify()) {
        const wo = window.open('', '_blank')
        this.loading = true
        this.generate()
        axios.post('http://plantravail.fr/pdf/index.php', this.$store.state)
        .then((r) => {
          this.loading = false
          this.done = true
          this.response = r.data
          wo.location.replace(r.data)
          setTimeout(() => {
            this.done = false
          }, 2000)
        })
      }
    },
    changeColor (e) {
      // console.log(e)
      this.color = e
    },
    generate () {
      this.$store.commit('setBeautifulPrice', this.beautify(this.$store.state.price))
      // prices in store
      this.$store.commit('setDevisPrice', {id: 0, price: this.beautify(this.$store.state.devis[1].largeur * this.$store.state.devis[1].longueur * this.groups[this.$store.state.devis[0].group].credence)})
      this.$store.commit('setDevisPrice', {id: 1, price: this.beautify(this.$store.state.devis[1].largeur * this.$store.state.devis[1].longueur * this.groups[this.$store.state.devis[0].group].credence)})
      this.$store.commit('setDevisPrice', {id: 2, price: this.beautify(this.$store.state.devis[2].longueur * this.chants[this.$store.state.devis[2].chant].price)})
      this.$store.commit('setDevisPrice', {id: 3, price: this.beautify(this.$store.state.devis[3].largeur * this.$store.state.devis[3].longueur * this.groups[this.$store.state.devis[0].group].credence)})
      this.$store.commit('setDevisMultiplePrice', {id: 4,
        subid: 'options',
        price: [
          this.beautify(this.options[0].price * this.$store.state.devis[4].options[0].quantity),
          this.beautify(this.options[1].price * this.$store.state.devis[4].options[1].quantity),
          this.beautify(this.options[2].price * this.$store.state.devis[4].options[2].quantity),
          this.beautify(this.options[3].price * this.$store.state.devis[4].options[3].quantity),
          this.beautify(this.options[4].price * this.$store.state.devis[4].options[4].quantity),
          this.beautify(this.options[5].price * this.$store.state.devis[4].options[5].quantity),
          this.beautify(this.options[6].price * this.$store.state.devis[4].options[6].quantity),
          this.beautify(this.options[7].price * this.$store.state.devis[4].options[7].quantity)
        ]
      })
      this.$store.commit('setDevisMultiplePrice', {id: 5,
        subid: 'services',
        price: [
          this.beautify(this.services[0].price * this.$store.state.devis[5].services[0].selected),
          this.beautify(this.services[1].price * this.$store.state.devis[5].services[1].selected),
          this.beautify(this.services[2].price * this.$store.state.devis[5].services[2].selected),
          this.beautify(this.services[3].price * this.$store.state.devis[5].services[3].selected),
          this.beautify(this.services[4].price * this.$store.state.devis[5].services[4].selected),
          this.beautify(this.services[5].price * this.$store.state.devis[5].services[5].selected),
          this.beautify(this.services[6].price * this.$store.state.devis[5].services[6].selected),
          this.beautify(this.services[7].price * this.$store.state.devis[5].services[7].selected)
        ]
      })

      // names
      this.$store.commit('setDevisInfo', {id: 2, subid: 'name', val: this.chants[this.$store.state.devis[2].chant].name})
      this.$store.commit('setDevisMultipleInfo', {id: 4,
        subid: 'options',
        val: [
          this.options[this.$store.state.devis[4].options[0].id].name,
          this.options[this.$store.state.devis[4].options[1].id].name,
          this.options[this.$store.state.devis[4].options[2].id].name,
          this.options[this.$store.state.devis[4].options[3].id].name,
          this.options[this.$store.state.devis[4].options[4].id].name,
          this.options[this.$store.state.devis[4].options[5].id].name,
          this.options[this.$store.state.devis[4].options[6].id].name,
          this.options[this.$store.state.devis[4].options[7].id].name
        ]
      })
      this.$store.commit('setDevisMultipleInfo', {id: 5,
        subid: 'services',
        val: [
          this.services[this.$store.state.devis[5].services[0].id].name,
          this.services[this.$store.state.devis[5].services[1].id].name,
          this.services[this.$store.state.devis[5].services[2].id].name,
          this.services[this.$store.state.devis[5].services[3].id].name,
          this.services[this.$store.state.devis[5].services[4].id].name,
          this.services[this.$store.state.devis[5].services[5].id].name,
          this.services[this.$store.state.devis[5].services[6].id].name,
          this.services[this.$store.state.devis[5].services[7].id].name
        ]
      })
      this.$store.commit('setBeautifulTvaTtc')
      // console.log(this.$store.state)
      // console.log(JSON.stringify(this.$store.state))
    }
  }
}
</script>

<style lang="css" scoped>

.service {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  align-items: center;
}
.devis {
  text-align: left;
  background-size: cover !important;
  background-position: center center !important;
  background-attachment: fixed!important;
}
.part {
  margin-bottom: 15px;
}
.devis-parts {
  width: 500px;
  z-index: 200;
  box-sizing: border-box;
  padding: 50px 30px;
  background: #000;
  color: #FFF;
}
.devis-fixed {
  position: fixed;
  top: 50px;
  left: 750px;
  padding: 20px 30px;
  box-sizing: border-box;
  background: #FFF;
  border: 1px solid #ebebeb;
  width: 450px;
  overflow: auto;
  max-height: 850px;
}
h1 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
}
.blue {
  color: #ff0000;
}
.separator {
  border-bottom: 1px solid #FFF;
  margin: 10px 0 20px 0;
}
.download {
  width: 100%;
  background: #ff0000;
  outline: none;
  border: 0;
  padding: 15px 0;
  color: #FFF;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
.devis-background {
  width: 100vw;
  height: 100vh;
  z-index: -1;
  background-size: cover !important;
  position: fixed;
  top: 0; left: 0;
}
.info {
  margin-top: 0;
  color: #fff;
  margin-bottom: 20px;
  font-weight: bold;
}
@keyframes spin {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}

.fa-circle-o-notch {
  margin-right: 10px;
  animation: spin .6s ease infinite;
}

</style>



// WEBPACK FOOTER //
// Devis.vue?57a513b2